import React, { useEffect, useState } from "react";
import { Col, Row, Button, Spinner } from "reactstrap";
import Flatpickr from "react-flatpickr";
import { useSelector } from "react-redux";
import { t } from "i18next";

const SectionV2 = (props) => {
  const { profile } = useSelector((state) => ({
    profile: state.Profile,
  }));
  const [userName, setUserName] = useState();
  const [activeFilter, setActiveFilter] = useState("today");

  useEffect(() => {
    setUserName(profile.user.firstName || t("Common.Admin"));
  }, [userName, profile]);

  const onChangeFilter = (filterType) => {
    setActiveFilter(filterType);
    let currentDate = new Date();
    switch (filterType) {
      case "allTime": {
        props.onChange([]);
        break;
      }
      case "today": {
        props.onChange([currentDate, currentDate]);
        break;
      }
      case "lastWeek": {
        // Find the current day of the week (0 = Sunday, 1 = Monday, ..., 6 = Saturday)
        var currentDayOfWeek = currentDate.getDay();

        // Calculate the difference in days between the current day and the start of the week (assuming Sunday as the start of the week)
        var daysToSubtract = (currentDayOfWeek + 7 - 1) % 7;

        // Subtract the days to get the start date of the last week
        var lastWeekStartDate = new Date(currentDate);
        lastWeekStartDate.setDate(currentDate.getDate() - daysToSubtract);

        // Subtract one day to get the end date of the last week
        var lastWeekEndDate = new Date(lastWeekStartDate);
        lastWeekEndDate.setDate(lastWeekStartDate.getDate() + 6);
        props.onChange([lastWeekStartDate, lastWeekEndDate]);
        break;
      }
      case "lastMonth": {
        // Set the date to the first day of the current month
        currentDate.setDate(1);
        // Subtract one day to get the last day of the previous month
        currentDate.setDate(0);
        // Get the last day of the previous month
        var lastMonthEndDate = new Date(
          currentDate.getFullYear(),
          currentDate.getMonth(),
          currentDate.getDate()
        );
        // Set the date to the first day of the previous month
        currentDate.setDate(1);
        // Get the start day of the previous month
        var lastMonthStartDate = new Date(
          currentDate.getFullYear(),
          currentDate.getMonth(),
          currentDate.getDate()
        );
        props.onChange([lastMonthStartDate, lastMonthEndDate]);
        break;
      }
      default:
        break;
    }
  };

  return (
    <React.Fragment>
      <Row className="mb-3 pb-1">
        <Col xs={12}>
          <div className="d-flex align-items-lg-center flex-lg-row flex-column">
            <div className="flex-grow-1">
              <h4 className="fs-16 mb-1">
                {t("Common.Hello")}, {userName}! &nbsp; &nbsp;
                {props.isApplyingNewFilter && (
                  <Spinner
                    size={"sm"}
                    className="flex-shrink-0"
                    role="status"
                  ></Spinner>
                )}
              </h4>
              <p className="text-muted mb-0">
                {t(`Dashboard.Here's what's happening with your app.`)}
              </p>
            </div>
            <div className="mt-3 mt-lg-0">
              <form action="#">
                <Row className="g-3 mb-0 align-items-center">
                  <div className="col-xs-auto">
                    {" "}
                    <div className="input-group">
                      <Button
                        color="primary"
                        outline
                        className={`${
                          activeFilter === "allTime" ? "active" : ""
                        }`}
                        onClick={() => onChangeFilter("allTime")}
                      >
                        {t("Common.All Time")}
                      </Button>
                      <Button
                        color="primary"
                        outline
                        className={`${
                          activeFilter === "today" ? "active" : ""
                        }`}
                        onClick={() => onChangeFilter("today")}
                      >
                        <span className="d-flex align-items-center">
                          {t("Common.Today")}
                        </span>
                      </Button>
                      <Button
                        color="primary"
                        outline
                        className={`${
                          activeFilter === "lastWeek" ? "active" : ""
                        }`}
                        onClick={() => onChangeFilter("lastWeek")}
                      >
                        {t("Common.Current Week")}
                      </Button>
                      <Button
                        color="primary"
                        outline
                        className={`${
                          activeFilter === "lastMonth" ? "active" : ""
                        }`}
                        onClick={() => onChangeFilter("lastMonth")}
                      >
                        {t("Common.Last Month")}
                      </Button>
                      <Flatpickr
                        className="form-control dash-filter-picker shadow flatpickr-border"
                        options={{
                          mode: "range",
                          dateFormat: "d M, Y",
                        }}
                        value={props.value}
                        onClose={(e) => {
                          props.onChange(e);
                          setActiveFilter(null);
                        }}
                      />
                      <div className="input-group-text bg-primary border-primary text-white">
                        <i className="ri-calendar-2-line"></i>
                      </div>
                    </div>
                  </div>
                </Row>
              </form>
            </div>
          </div>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default SectionV2;
